import { SecondaryItem, ESecondaryItemType } from "@similarweb/ui-components";

import type { INavItem } from "app/components/sidebar3/types";
import { isLocked, isHidden } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";
import {
    INDUSTRY_SEGMENTATION_CONFIG_ID,
    MARKET_RESEARCH_PERFORMANCE_CONFIG_ID,
} from "app/pages/industry-analysis/config/const";
import { applyNavItemPermissions } from "app/pages/workspace/common/workspacesUtils";

interface IIndustryNavItem extends INavItem {
    customFilter?: () => boolean;
    supportSegment?: boolean;
    subItems?: Array<IIndustryNavItem>;
}

type IIndustryNavItems = Array<IIndustryNavItem>;

const getWebMarketAnalysisGroup = (): IIndustryNavItems => [
    {
        title: "sidebar.marketresearch.web.overview.marketresearch.title.market",
        name: "researchOverview",
        state: "market_research_overview_v2",
        lockIcon: isLocked(swSettings.components.MarketResearchOverview),
        hidden: isHidden(swSettings.components.MarketResearchOverview),
        itemComponent: SecondaryItem,
        itemType: ESecondaryItemType.StandaloneReport,
        supportSegment: true,
    },
    {
        title: "digitalsuite.sidebar.industryAnalysis.trafficChannels.title",
        name: "trafficChannels",
        state: "market_research_traffic_channels_v2",
        lockIcon: isLocked(swSettings.components.IndustryAnalysisMarketingChannels),
        hidden: isHidden(swSettings.components.IndustryAnalysisMarketingChannels),
        itemComponent: SecondaryItem,
        itemType: ESecondaryItemType.StandaloneReport,
        supportSegment: true,
    },
    {
        title: "sidebar.marketresearch.web.marketo.segmentation.title",
        name: "segmentation",
        state: "market_research_segmentation_v2",
        lockIcon: isLocked(swSettings.components[INDUSTRY_SEGMENTATION_CONFIG_ID]),
        hidden: isHidden(swSettings.components[INDUSTRY_SEGMENTATION_CONFIG_ID]),
        itemComponent: SecondaryItem,
        itemType: ESecondaryItemType.StandaloneReport,
    },
    {
        title: "sidebar.market.research.title.market.players",
        name: "players",
        state: "market_research_players_v2",
        lockIcon: isLocked(swSettings.components[MARKET_RESEARCH_PERFORMANCE_CONFIG_ID]),
        hidden: isHidden(swSettings.components[MARKET_RESEARCH_PERFORMANCE_CONFIG_ID]),
        itemComponent: SecondaryItem,
        itemType: ESecondaryItemType.StandaloneReport,
        supportSegment: true,
    },
    {
        title: "industryAnalysis.geo.title",
        name: "geography",
        lockIcon: isLocked(swSettings.components.IndustryAnalysisGeography),
        hidden: isHidden(swSettings.components.IndustryAnalysisGeography),
        state: "market_research_geography_v2",
        itemComponent: SecondaryItem,
        itemType: ESecondaryItemType.StandaloneReport,
    },
    {
        title: "industryAnalysis.demand.trends.title",
        name: "searchTrends",
        lockIcon: isLocked(swSettings.components.IndustrySearchInterests),
        hidden: isHidden(swSettings.components.IndustrySearchInterests),
        state: "market_research_demand_trends_v2",
        itemComponent: SecondaryItem,
        itemType: ESecondaryItemType.StandaloneReport,
    },
    {
        title: "industryAnalysis.demographics.page.title",
        name: "demographics",
        lockIcon: isLocked(swSettings.components.IndustryAnalysisDemographics),
        hidden: isHidden(swSettings.components.IndustryAnalysisDemographics),
        state: "market_research_demography_v2",
        itemComponent: SecondaryItem,
        itemType: ESecondaryItemType.StandaloneReport,
    },
];

const navFilter = (item) => (item.customFilter ? item.customFilter() : true);

export const industryResearchNavObj31 = (hasSelectedCategoryWithSegments: boolean): { navList: IIndustryNavItems } => {
    const navItems = getWebMarketAnalysisGroup()
        .filter(navFilter)
        .map((navItem) => {
            if (!navItem.subItems) {
                return navItem;
            }
            const { subItems = [] } = navItem;
            const filteredSubItems = subItems.filter(navFilter);
            return { ...navItem, subItems: filteredSubItems };
        });

    const navItemGroups = hasSelectedCategoryWithSegments
        ? navItems.filter(({ supportSegment }) => supportSegment)
        : navItems;
    return {
        navList: navItemGroups.map(applyNavItemPermissions),
    };
};
